import { render, staticRenderFns } from "./permissionCheckbox.vue?vue&type=template&id=612c659b&scoped=true&"
import script from "./permissionCheckbox.vue?vue&type=script&lang=ts&"
export * from "./permissionCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./permissionCheckbox.vue?vue&type=style&index=0&id=612c659b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612c659b",
  null
  
)

export default component.exports